import React from 'react';
import '../styles/footer.css';
import {
  FaEnvelope, FaPhone, FaMapMarkerAlt,
  FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter,
  FaArrowRight, FaRecycle,
  FaArrowUp,
  FaHome, FaInfoCircle, FaConciergeBell, FaImages,
  FaLaptop, FaHdd, FaTruck, FaCertificate
} from 'react-icons/fa';

const Footer = () => {
  const year = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home',     href: '/',         icon: FaHome          },
    { label: 'About',    href: '/about',    icon: FaInfoCircle    },
    { label: 'Services', href: '/services', icon: FaConciergeBell },
    { label: 'Gallery',  href: '/galary',   icon: FaImages        },
    { label: 'Contact',  href: '/contact',  icon: FaEnvelope      },
  ];

  const services = [
    { label: 'IT Asset Disposal', href: '/services', icon: FaLaptop      },
    { label: 'Metal Recycling',   href: '/allmetal', icon: FaRecycle     },
    { label: 'Data Destruction',  href: '/services', icon: FaHdd         },
    { label: 'Bulk Pickup',       href: '/contact',  icon: FaTruck       },
    { label: 'Eco Certification', href: '/services', icon: FaCertificate },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">

      {/* ── Top action strip ── */}
      <div className="footer-strip">
        <div className="footer-container">
          <div className="footer-strip-inner">
            <div className="footer-strip-left">
              <span className="strip-icon-badge"><FaRecycle /></span>
              <span>Responsible Recycling for a Greener Tomorrow</span>
            </div>
            <a href="/contact" className="strip-cta">
              Get a Free Quote <FaArrowRight />
            </a>
          </div>
        </div>
      </div>

      {/* ── Main footer body ── */}
      <div className="footer-body">
        <div className="footer-container">
          <div className="footer-grid">

            {/* Brand */}
            <div className="footer-brand">
              <div className="footer-logo-wrap">
                <img
                  src="/logo1.png"
                  alt="KMK Industries"
                  className="footer-logo-img"
                />
              </div>

              <p className="footer-about">
                Specialists in comprehensive e-waste recycling and metal scrap management —
                delivering environmentally responsible solutions for businesses across India.
              </p>

              <div className="footer-socials">
                <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noreferrer"><FaFacebookF /></a>
                <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noreferrer"><FaInstagram /></a>
                <a href="https://linkedin.com" aria-label="LinkedIn" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
                <a href="https://twitter.com" aria-label="Twitter" target="_blank" rel="noreferrer"><FaTwitter /></a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-links">
                {quickLinks.map(({ label, href, icon: Icon }) => (
                  <li key={label}>
                    <a href={href}>
                      <span className="link-icon"><Icon /></span>
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div className="footer-col">
              <h4 className="footer-heading">Services</h4>
              <ul className="footer-links">
                {services.map(({ label, href, icon: Icon }) => (
                  <li key={label}>
                    <a href={href}>
                      <span className="link-icon"><Icon /></span>
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-col footer-col-contact">
              <h4 className="footer-heading">Contact Us</h4>
              <ul className="footer-contact-list">
                <li>
                  <span className="contact-icon-wrap"><FaEnvelope /></span>
                  <div>
                    <span className="contact-label">Email</span>
                    <a href="mailto:kmkindustries22@gmail.com">kmkindustries22@gmail.com</a>
                  </div>
                </li>
                <li>
                  <span className="contact-icon-wrap"><FaPhone /></span>
                  <div>
                    <span className="contact-label">Phone</span>
                    <a href="tel:+918762414394">+91 87624 14394</a>
                    <a href="tel:+919972474042">+91 99724 74042</a>
                  </div>
                </li>
                <li>
                  <span className="contact-icon-wrap"><FaMapMarkerAlt /></span>
                  <div>
                    <span className="contact-label">Address</span>
                    <p>
                      #19, New No 13/9, Bilwaradahalli,<br />
                      Shanubhoganahalli Main Road,<br />
                      Jigani (H), Anekal (T),<br />
                      Bangalore – 560083
                    </p>
                  </div>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-inner">
            <p>© {year} <span>KMK Industries</span>. All rights reserved.</p>

            <p className="footer-bottom-right">
              Designed with <span className="heart">♥</span> for a greener planet
            </p>

            <button
              type="button"
              className="footer-top-btn"
              onClick={scrollToTop}
              aria-label="Back to top"
            >
              <FaArrowUp />
            </button>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
